import type { RecaptchaAction } from '../../supabase/functions/_shared/recaptchaActions';
import {
  parseRecaptchaMode,
  type RecaptchaVerificationMode,
} from '../../supabase/functions/_shared/recaptchaMode';

export const RECAPTCHA_PUBLIC_ERROR = 'Unable to verify this request. Please try again.';

export type RecaptchaRequestProof =
  | Readonly<{ mode: 'disabled' }>
  | Readonly<{ mode: RecaptchaVerificationMode; token: string }>;

export function recaptchaTokenPayload(
  proof: RecaptchaRequestProof,
): Readonly<{ recaptchaToken?: string }> {
  return proof.mode === 'disabled' ? {} : { recaptchaToken: proof.token };
}

export async function createRecaptchaRequestProof(
  action: RecaptchaAction,
): Promise<RecaptchaRequestProof> {
  const configuredMode = import.meta.env.VITE_RECAPTCHA_MODE;

  // Keep this as a direct build-time comparison. Vite/Rollup can then remove
  // the enabled-only dynamic import from an explicitly disabled artifact.
  if (import.meta.env.VITE_RECAPTCHA_MODE === 'disabled') {
    return { mode: 'disabled' };
  }

  const mode = parseRecaptchaMode(configuredMode);
  if (mode === 'disabled') throw new Error('recaptcha_mode_invalid');

  const { executeRecaptchaAction } = await import('@/lib/recaptchaEnterprise');
  const token = await executeRecaptchaAction(action);
  return { mode, token };
}
